<template>
    <table-page
        v-if="isload"
        :page-info="pageInfo"
        :page-type="pageInfo.page_type"
        @update:topSearch="topSearch"
        @update:topBut="topBut"
        @update:nodeBut="nodeBut"
        @update:PageSizeChange="PageSizeChange"
        @update:toPage="toPage"
        @update:handleSelectionChange="handleSelectionChange"
        @update:nodeSwitchChange="nodeQuickEdit"
        @update:nodeQuickEdit="nodeQuickEdit"
        @update:onTabChange="onTabChange"
        @update:sortChange="sortChange"
        @update:filterTime="filterTime"
        @update:selectList="selectList"
        @update:dialogClosed="dialogClosed"
    />
    <add ref="addFormRef" :title="formTitle" :urls="urls" @update:getDataList="getDataList" />
    <slot></slot>
</template>

<script>
    import { defineComponent, getCurrentInstance, inject, ref, provide, reactive, toRefs, nextTick } from 'vue'
    import TablePage from '@/components/ui-table-page'
    import Add from '../form/index'

    export default defineComponent({
        components: {
            TablePage,
            Add
        },
        props: {
            isMiniPage: {
                type: Boolean,
                default: false
            },
            butNoManage: {
                type: Array,
                default: () => []
            },
            propsUrls: {
                type: Object,
                default: () => {}
            }
        },
        setup(props, context) {
            const noManage = ref({
                topAdd: false,
                topEnable: false,
                topDisable: false,
                topDelete: false,
                nodeAdd: false,
                nodeEdit: false,
                nodeEnable: false,
                nodeDisable: false,
                nodeDelete: false,
                autoGetList: false
            })
            if (props.butNoManage.length > 0) {
                props.butNoManage.map((item) => {
                    noManage.value[item] = true
                })
            }
            const { proxy } = getCurrentInstance()
            const isload = ref(false)
            const dataList = ref([])
            const addFormRef = ref()
            const formTitle = ref()
            const pageInfo = ref()
            const map = reactive({
                'keyword': ''
            })
            const selectIds = reactive([])
            const dialogVisible = ref(true)
            const urls = ref(proxy.$router.currentRoute.value.meta.urls)
            const tabNav = ref()
            if (props.propsUrls) {
                urls.value = props.propsUrls
            }
            const queryRoute = proxy.$router.currentRoute.value.query
            const getDataList = (maps = {}) => {
                let mapObj = Object.assign(map, maps, queryRoute)
                proxy.jiu.request(urls.value.list, mapObj).then((res, rej) => {
                    let data = res.data
                    dataList.value = data.data_list
                    delete data.data_list
                    pageInfo.value = res.data
                    tabNav.value = res.data.tab_nav
                    isload.value = true
                    context.emit('update:isLoad', true)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }
            const onTabChange = (e) => {
                isload.value = false
                map.page = 1
                map.keyword = ''
                map.group = e
                getDataList()
            }

            if (!noManage.value.autoGetList) {
                getDataList()
            }

            const toPage = (e) => {
                map.page = e
                getDataList()
            }
            const PageSizeChange = (e) => {
                map.page = 1
                map.list_rows = e
                getDataList()
            }

            const edit = (url, obj) => {
                proxy.jiu.request(url, obj).then((res, rej) => {
                    proxy.jiu.toast(res.message)
                    getDataList()
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const topSearch = (f, k) => {
                map.keyword = k
                map.search_field = f
                getDataList()
            }

            const topBut = (e, href) => {
                context.emit('update:topBut', e, href)
                if (e === 'Add' && !noManage.value.topAdd) {
                    topButAdd(href)
                } else if (e === 'Enable' && !noManage.value.topEnable) {
                    topButEnable(href)
                } else if (e === 'Disable' && !noManage.value.topDisable) {
                    topButDisable(href)
                } else if (e === 'Delete' && !noManage.value.topDisable) {
                    topButDelete(href)
                } else {
                    if (!['Add', 'Enable', 'Disable', 'Delete'].includes(e) && !noManage.value['top' + e]) topButCustom(e, href)
                }
            }

            const topButAdd = (href = '') => {
                formTitle.value = '新增'
                let obj = {}
                if (map.group) {
                    obj['group'] = tabNav.value.curr_tab
                }
                let url = ''
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, href.query)
                }
                addFormRef.value.add(obj, url)
            }
            const topButEnable = (href = '') => {
                let obj = { ids: selectIds.value }
                let url = urls.value.enable
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, href.query)
                }
                edit(url, obj)
            }
            const topButDisable = (href = '') => {
                let obj = { ids: selectIds.value }
                let url = urls.value.disable
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, href.query)
                }
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        edit(url, obj)
                    }
                }, 'warning')
            }
            const topButDelete = (href = '') => {
                let obj = { ids: selectIds.value }
                let url = urls.value.delete
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, href.query)
                }
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        edit(url, obj)
                    }
                }, 'warning')
            }
            const topButCustom = (e, href = '') => {
                let obj = { ids: selectIds.value }
                obj = Object.assign(obj, href.query)
                let url = href.url
                if (href.type === 'edit') {
                    edit(url, obj)
                } else if (href.type === 'add') {
                    if (map.group) {
                        obj['group'] = tabNav.value.curr_tab
                    }
                    addFormRef.value.add(obj, url)
                } else {
                    proxy.$router.push({
                        path: url,
                        query: href.query
                    })
                }
            }

            const nodeBut = (e, d, href) => {
                context.emit('update:nodeBut', e, d, href)
                if (e === 'Add' && !noManage.value.nodeAdd) {
                    nodeButAdd(d, href)
                } else if (e === 'Edit' && !noManage.value.nodeEdit) {
                    nodeButEdit(d, href)
                } else if (e === 'Enable' && !noManage.value.nodeEnable) {
                    nodeButEnable(d, href)
                } else if (e === 'Disable' && !noManage.value.nodeDisable) {
                    nodeButDisable(d, href)
                } else if (e === 'Delete' && !noManage.value.nodeDelete) {
                    nodeButDelete(d, href)
                } else {
                    if (!['Add', 'Edit', 'Enable', 'Disable', 'Delete'].includes(e) && !noManage.value['node' + e]) nodeButCustom(e, d, href)
                }
            }

            const nodeButAdd = (data, href = '') => {
                let query = matchQuery(data, href.query)
                formTitle.value = '新增'
                let obj = {}
                obj[pageInfo.value.primary_key] = data[pageInfo.value.primary_key]
                if (map.group) {
                    obj['group'] = tabNav.value.curr_tab
                }
                let url = urls.value.add
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, query)
                }
                addFormRef.value.add(obj, url)
            }
            const nodeButEnable = (data, href = '') => {
                let query = matchQuery(data, href.query)
                let obj = { ids: data[pageInfo.value.primary_key] }
                let url = urls.value.enable
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, query)
                }
                edit(url, obj)
            }
            const nodeButDisable = (data, href = '') => {
                let query = matchQuery(data, href.query)
                let obj = { ids: data[pageInfo.value.primary_key] }
                let url = urls.value.disable
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, query)
                }
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        edit(url, obj)
                    }
                }, 'warning')
            }
            const nodeButEdit = (data, href = '') => {
                let query = matchQuery(data, href.query)
                let obj = { }
                obj[pageInfo.value.primary_key] = data[pageInfo.value.primary_key]
                let url = urls.value.edit
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, query)
                }
                formTitle.value = '编辑'
                addFormRef.value.edit(obj, url)
            }
            const nodeButDelete = (data, href = '') => {
                let query = matchQuery(data, href.query)
                let obj = { ids: data[pageInfo.value.primary_key] }
                let url = urls.value.delete
                if (href) {
                    url = href.url
                    obj = Object.assign(obj, query)
                }
                proxy.jiu.modal('温馨提示', '您确定要执行此操作吗！！', true, (e) => {
                    if (e) {
                        edit(url, obj)
                    }
                }, 'warning')
            }
            const nodeButCustom = (e, data, href = '') => {
                let query = matchQuery(data, href.query)
                let obj = { ids: data[pageInfo.value.primary_key] }
                obj = Object.assign(obj, query)
                let url = href.url
                if (href.type === 'edit') {
                    edit(url, obj)
                } else if (href.type === 'add') {
                    if (map.group) {
                        obj['group'] = tabNav.value.curr_tab
                    }
                    addFormRef.value.add(obj, url)
                } else {
                    proxy.$router.push({
                        path: url,
                        query: query
                    })
                }
            }
            const matchQuery = (data, query = '') => {
                let reg = /__(.*?)__/
                let qq = {}
                for (let i in query) {
                    if (reg.test(query[i])) {
                        let result = query[i].match(reg)
                        qq[i] = data[result[1]]
                    } else {
                        qq[i] = query[i]
                    }
                }
                return qq
            }
            const handleSelectionChange = (e) => {
                let list = e
                let ids = []
                list.forEach((item, index) => {
                    ids.push(item[pageInfo.value.primary_key])
                })
                selectIds.value = ids
                context.emit('update:handleSelectionChange', ids)
            }
            const nodeQuickEdit = (id, data, field) => {
                let url = urls.value.quickedit
                let obj = { id: id, value: data, name: field }
                if (pageInfo.value.quick_edit_url) {
                    url = pageInfo.value.quick_edit_url.url
                    obj = Object.assign(obj, pageInfo.value.quick_edit_url.query)
                }
                proxy.jiu.request(url, obj).then((res, rej) => {
                    proxy.jiu.toast(res.message)
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
                getDataList()
            }

            const sortChange = (e) => {
                let f = Object.keys(e)[0]
                let by = e[f]
                map.order_order = pageInfo.value.order_columns[f]
                let sc = ''
                if (by && by === 'descending') {
                    sc = 'desc'
                }
                if (by && by === 'ascending') {
                    sc = 'asc'
                }
                if (sc) {
                    map.order_by = sc
                    getDataList()
                }
            }

            const filterTime = (e) => {
                let filter_time_from = ''
                let filter_time_to = ''
                if (e) {
                    filter_time_from = e[0]
                    filter_time_to = e[1]
                }
                map.filter_time = pageInfo.value.filter_time.field
                map.filter_time_from = filter_time_from
                map.filter_time_to = filter_time_to
                getDataList()
            }
            const selectValues = ref([])
            const selectList = (e, a) => {
                selectValues.value[e] = a
                map.select_field = Object.keys(selectValues.value).join('|')
                map.select_value = Object.values(selectValues.value).join('|')
                getDataList()
            }

            provide('dataList', dataList)
            provide('dialogVisible', dialogVisible)

            // 当页面作为子弹窗页面时的调用
            const minPageShow = () => {
                dialogVisible.value = true
            }
            const dialogClosed = () => {
                context.emit('update:dialogClosed')
            }
            return {
                isload,
                pageInfo,
                map,
                dataList,
                formTitle,
                addFormRef,
                urls,

                handleSelectionChange,
                sortChange,
                filterTime,
                selectList,
                toPage,
                PageSizeChange,
                getDataList,

                nodeQuickEdit,
                nodeBut,
                topBut,
                topSearch,

                onTabChange,

                minPageShow,
                dialogClosed
            }
        }
    })
</script>

<style scoped>
</style>
